import { useTranslations } from 'next-intl'

import ViverseButton from '@/components/ViverseButton'
import Loader from '@/components/Loader'

type LoadMoreButtonProps = {
  isLoading?: boolean
  hidden?: boolean
  onClick?: () => void
}

function LoadMoreButton({ onClick, hidden, isLoading }: LoadMoreButtonProps) {
  const t = useTranslations()

  if (isLoading) {
    return (
      <ViverseButton
        disabled
        className="m-auto w-[160px] cursor-wait!"
        variant="secondary"
        type="button"
      >
        <Loader className="m-1 size-4" />
      </ViverseButton>
    )
  }

  if (hidden) return null

  return (
    <ViverseButton className="m-auto w-[160px]" variant="secondary" type="button" onClick={onClick}>
      {t('profile-page.my-worlds-section-cta')}
    </ViverseButton>
  )
}

export default LoadMoreButton
